import Actionbar from './Actionbar/index.js';
import Arrow from './Arrow/index.js';
import BottomNavigation from './BottomNavigation/index.js';
import Functional from './Functional/index.js';
import { Header } from './Header/index.js';
import Mathematics from './Mathematics/index.js';
import Navigation from './Navigation/index.js';
import State from './State/index.js';
import XShape from './XShape/index.js';
import LoadingSpinner from './LoadingSpinner/index.js';

var Icon = {
    Actionbar: Actionbar,
    Arrow: Arrow,
    BottomNavigation: BottomNavigation,
    Functional: Functional,
    Header: Header,
    Mathematics: Mathematics,
    Navigation: Navigation,
    State: State,
    XShape: XShape,
    LoadingSpinner: LoadingSpinner,
};

export { Icon as default };
